{
  "auth.sign_in.title": "Sign in",
  "auth.sign_in.body": "Sign in to reach the calendar.",
  "auth.sign_in.email": "Email address",
  "auth.sign_in.password": "Password",
  "auth.sign_in.submit": "Sign in",
  "auth.sign_in.working": "Signing in …",
  "auth.sign_in.failed": "That email address or password is not right.",
  "auth.sign_in.forgot": "Forgotten your password?",
  "auth.sign_in.no_account": "No account yet? Ask your franchisee for an invitation.",
  "auth.sign_in.image_alt": "Work in a ColorGlo workshop",
  "auth.sign_out": "Sign out",
  "invite.title": "Welcome to ColorGlo",
  "invite.body": "Pick a password and you are up and running.",
  "invite.name": "Your name",
  "invite.password": "Password",
  "invite.password_hint": "At least 12 characters.",
  "invite.submit": "Create the account",
  "invite.done": "The account is ready. Sign in and you are at the calendar.",
  "invite.missing": "The link is missing an invitation. Ask your manager for a new one.",
  "auth.email.invitation.subject": "You're invited to {workshop}",
  "auth.email.invitation.heading": "Welcome to {workshop}",
  "auth.email.invitation.body": "You've been invited to the booking calendar for {workshop}. Choose a password to get started. The link is valid for 14 days.",
  "auth.email.invitation.cta": "Create your account",
  "auth.email.password_reset.subject": "Choose a new password for ColorGlo",
  "auth.email.password_reset.heading": "New password",
  "auth.email.password_reset.body": "{workshop} has sent you a link to choose a new password. The link is valid for 24 hours and works once.",
  "auth.email.password_reset.cta": "Choose a new password",
  "auth.email.email_changed.subject": "Your ColorGlo login has changed",
  "auth.email.email_changed.heading": "New email address for signing in",
  "auth.email.email_changed.body": "{workshop} has changed the email address you sign in with. Contact your manager if you don't recognise this change.",
  "auth.email.email_changed.cta": "Sign in",
  "reset.title": "Choose a new password",
  "reset.body": "Your new password replaces the old one. You'll be signed out on every device.",
  "reset.password": "New password",
  "reset.password_hint": "At least 12 characters.",
  "reset.submit": "Save password",
  "reset.done": "Your password is saved. Sign in with the new password.",
  "reset.missing": "This link has no reset in it. Ask your manager for a new one.",
  "reset.failed": "This link no longer works. Ask your manager for a new one.",
  "invite.owner_title": "Welcome, {name}",
  "invite.owner_body": "Pick a password for the workshop's account.",
  "invite.email": "Email",
  "invite.activate_body": "The account already exists. Activate to add {name}.",
  "invite.activate": "Activate",
  "invite.invalid": "This invitation is invalid or has expired. Ask for a new one.",
  "auth.change_password.title": "Change password",
  "auth.change_password.body": "Your other sign-ins are signed out once the password is changed.",
  "auth.change_password.current": "Current password",
  "auth.change_password.new": "New password",
  "auth.change_password.confirm": "Repeat new password",
  "auth.change_password.mismatch": "The passwords don't match.",
  "auth.change_password.failed": "The current password is wrong.",
  "auth.change_password.submit": "Change password",
  "auth.change_password.done": "Your password has been changed."
}
